import React from 'react'
import { i18nText } from '../../../Services';

export const Label = props => {
    const { text } = props;
    
    return (
        <label>
            { i18nText.exists(text) && <label className={ "control-label" }>{i18nText.getText(text) === " " ? <>&nbsp;</> : i18nText.getText(text)}</label>}
        </label>        
    )
}

export default Label;
